import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SyncOverview } from "@/components/admin-sync/SyncOverview";
import { ApiKeyCard } from "@/components/admin-sync/ApiKeyCard";
import { ApkCard } from "@/components/admin-sync/ApkCard";
import { OwnerSyncCard } from "@/components/admin-sync/OwnerSyncCard";
import { IntegrationTabs } from "@/components/admin-sync/IntegrationTabs";

export default function AdminSync() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadStatus = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/sync/status");
      setStatus(data);
    } catch (e) {
      toast.error("Failed to load sync status");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadStatus(); }, []);

  return (
    <div className="space-y-6 max-w-6xl">
      <SyncOverview status={status} loading={loading} loadStatus={loadStatus} />
      <ApiKeyCard />
      <ApkCard />
      <OwnerSyncCard onSynced={loadStatus} />
      <IntegrationTabs />
    </div>
  );
}
